<template>
  <b-modal :id="id" :title="title">
    <!-- <template v-slot:modal-header="{ close }">
      <b-button size="sm" variant="outline-danger" @click="close">Close Modal</b-button>
      <h5>Modal Header</h5>
    </template>-->

    <!-- <template v-slot:modal-title>
      <h4>{{title}}</h4>
    </template>-->

    <template>
      <slot></slot>
    </template>

    <template v-slot:modal-footer="{ok}">
      <slot name="footer"></slot>
      <!-- <b-button
        size="sm"
        variant="outline-secondary mr-1"
        @click="$emit('clear')"
        >Reset All Filters</b-button
      >-->
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="primary" @click="ok">OK</b-button>

      <!-- Button with custom close trigger value -->
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
}
</script>
